/* eslint-disable prefer-const */
import {Directive, ElementRef, Input, OnChanges, SimpleChanges} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

import { filter } from 'rxjs';

@Directive({
  selector: '[imageLinks]',
})
export class ImageLinksDirective implements OnChanges {
  @Input() imageLinks: any;

  constructor(
    private router: Router,
    private el: ElementRef) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
      )
      .subscribe(() => {
        if (this.imageLinks) {
          setTimeout(() => {
            this.setLinks();
          }, 0);
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.imageLinks.currentValue) {
      this.setLinks();
    }
  }

  setLinks() {
    const images = this.el.nativeElement.querySelectorAll('img[data-link]');
    // const parentNode = this.el.nativeElement;

    for (const img of images) {
      const imageLink = img.dataset['link'];

      let imageLinkWrapper: any;
      let imgClone: any;

      imageLinkWrapper = document.createElement('a');
      imageLinkWrapper.href = imageLink;
      imageLinkWrapper.target = '_blank';
      imageLinkWrapper.style.display = 'block';
      imgClone = img.cloneNode();
      imageLinkWrapper.appendChild(imgClone);
      imageLinkWrapper.className = 'image--link';

      img.replaceWith(imageLinkWrapper);
    }
  }
}
